import { IMRBaseComponent } from "../../../../../common/base"

import { OPERATOR_SECURITY_SERVICE_NAME } from "../../../../../../services/operator"
import { USER_SESSION_SERVICE_NAME } from "../../../../../../services/user-session"
import { SYSTEM_SERVICE_NAME } from "../../../../../../services/system"

import { OperatorDetailsSecurityController } from "./operator-details.security.controller"

//#region Asset Imports

import './operator-details.security.scss'
import * as TEMPLATE from './operator-details.security.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'operatorDetailsSecurity'

export class OperatorDetailsSecurityComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: OperatorDetailsSecurityController,
            services: [
                SYSTEM_SERVICE_NAME,
                USER_SESSION_SERVICE_NAME,
                OPERATOR_SECURITY_SERVICE_NAME,
            ],
            template: TEMPLATE
        })
    }
}